class SimplePreloader extends Phaser.Scene
{
	constructor(nextSceneKey)
	{
		super({ key: "simplePreloader" });

		this.nextSceneKey = nextSceneKey;
	}

	preload()
	{
		var self = this;
		var width = this.cameras.main.width;
		var height = this.cameras.main.height;
		var progressBar = this.add.graphics();
		var progressBox = this.add.graphics();

		progressBox.fillStyle(0x222222, 0.8);
		progressBox.fillRect((width - 320) / 2, height / 2 - 28, 320, 50);

		var loadingText = this.make.text({
			x: width / 2,
			y: height / 2 - 50,
			text: "Loading...",
			style: { font: "20px monospace", fill: "#ffffff" }
		});
		loadingText.setOrigin(0.5, 0.5);

		var percentText = this.make.text({
			x: width / 2,
			y: height / 2 - 2,
			text: "0%",
			style: { font: "18px monospace", fill: "#ffffff" }
		});
		percentText.setOrigin(0.5, 0.5);

		this.load.on("progress", function(value) {
			percentText.setText(parseInt(value * 100) + "%");
			progressBar.clear();
			progressBar.fillStyle(0x3587e2, 1);
			progressBar.fillRect((width - 300) / 2, height / 2 - 18, 300 * value, 30);
		});

		this.load.on("complete", function() {
			progressBar.destroy();
			progressBox.destroy();
			loadingText.destroy();
			percentText.destroy();
			//percentText.setText("100%");
		});

		//for (var i = 0; i < 100; i++) this.load.image("logo" + i, "assets/sky.jpg");

		this.load.image("sky", require("../assets/sky.jpg"));
		this.load.image("moon", require("../assets/moon.jpg"));
		this.load.image("particle", require("../assets/bomb.png"));
		this.load.image("level-main", require("../assets/level-main.jpg"));
		this.load.image("photo1", require("../assets/level-photo1.jpg"));
		this.load.image("photo2", require("../assets/level-photo2.jpg"));

		this.load.spritesheet("platforms", require("../assets/platforms.png"), { frameWidth: 50, frameHeight: 40 });
		this.load.spritesheet("player", require("../assets/player-sheet.png"), { frameWidth: 50, frameHeight: 40 });
		this.load.spritesheet("things", require("../assets/things.png"), { frameWidth: 50, frameHeight: 40 });

		this.load.audio("music", require("../assets/sounds/ROAR_Entertainment_Martians.mp3"));
		this.load.audio("sound-click", require("../assets/sounds/click.mp3"));
		this.load.audio("sound-eat", require("../assets/sounds/eat.mp3"));
		this.load.audio("sound-fall", require("../assets/sounds/fall.mp3"));
		this.load.audio("sound-fire", require("../assets/sounds/fire.mp3"));
		this.load.audio("sound-ice", require("../assets/sounds/ice.mp3"));
		this.load.audio("sound-teleport", require("../assets/sounds/teleport.mp3"));
		this.load.audio("sound-win", require("../assets/sounds/win.mp3"));
	}

	create()
	{
		this.scene.start(this.nextSceneKey);
	}
}

export default SimplePreloader;